import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Card from '@welldev-group/rcl-card';
import Icon from '@welldev-group/rcl-icon';
import {
  I18nText,
  Avatar,
  KpiCard,
  Link,
  PillTabs,
} from '@welldev-group/react-comp-lib';
import ContentLoaderPlaceholder from '@welldev-group/rcl-content-loader-placeholder';
// import { v4 as uuidv4 } from 'uuid';

import meter from 'affiliateIcons/meter.svg';
/*
Temporarily commented out as part of disabling the Twitter newsfeed.
To be re-enabled under the following story
TODO: https://welldev-group.atlassian.net/browse/AF-1429

import feed from 'affiliateIcons/feed.svg';
import twitterIcon from '../../../../assets/images/logo-X-black.png';

import Tweet from '../Tweet';
*/
import NewsBody from './NewsBody';
import httpClient from '../../../shared/libraries/httpClient';
import routes from '../../../shared/routes';

const dashboard = ({
  userName,
  accountManagerFirstName,
  accountManagerLastName,
  accountManagerAvatar,
  profilesAddedKPI,
  searchesKPI,
  quotesKPI,
  bookingsKPI,
  travelerDeparting,
  travelerArriving,
  travelerTravelling,
  // tweets,
  travelNews,
  welltravelNews,
}) => {
  const [briefingTasks, setBriefingTasks] = useState([]);
  const [isTaskLoading, setIsTaskLoading] = useState(true);

  const allTravelNews = (
    <NewsBody key="travelNews" newsList={travelNews} newsCategory="travel" />
  );

  const onlyWelltravelNews = (
    <NewsBody
      key="welltravelNews"
      newsList={welltravelNews}
      newsCategory="welltravel"
    />
  );

  const newsListTabs = [
    {
      key: 0,
      title: <I18nText id="dashboard.news.travel_news.header" />,
      getContent: () => allTravelNews,
    },
    {
      key: 1,
      title: <I18nText id="dashboard.news.welltravel_news.header" />,
      getContent: () => onlyWelltravelNews,
    },
  ];

  const totalTasksCount = () => {
    let count = 0;
    if (briefingTasks.length) {
      briefingTasks.forEach(workspace => {
        count += workspace.tasks.length;
      });
    }
    return count;
  };

  const briefingTaskRows = tasks =>
    tasks.map(task => (
      <div className="dashboard__briefing-tasks-list-row">
        <Link
          href={task.url}
          openNewTab={true}
          modifier="tertiary"
          size="small"
        >
          {task.title}
        </Link>
      </div>
    ));

  const accountManagerSection = () => {
    return (
      <div className="dashboard__account-manager-section">
        <div className="dashboard__account-manager-image">
          <Avatar
            src={accountManagerAvatar}
            size="large"
            firstName={accountManagerFirstName}
            lastName={accountManagerLastName}
          />
        </div>
        <div className="dashboard__account-manager-sub-section">
          <div className="dashboard__account-manager-text">
            {I18n.t('activerecord.attributes.affiliate.account_manager')}
          </div>
          <div className="dashboard__account-manager-name">
            {accountManagerFirstName} {accountManagerLastName}
          </div>
        </div>
      </div>
    );
  };

  /* const emptySocialCard = () => {
    return (
      <>
        <div className="dashboard__social-icon">
          <img src={feed} alt="pending-payments" />
        </div>
        <div className="dashboard__social-empty-text">
          <I18nText id="dashboard.social.empty" />
        </div>
      </>
    );
  }; */

  const kpiCards = () => {
    const isKpiDataAvailble =
      profilesAddedKPI.past +
        profilesAddedKPI.present +
        searchesKPI.past +
        searchesKPI.present +
        quotesKPI.past +
        quotesKPI.present +
        bookingsKPI.past +
        bookingsKPI.present >
      0;

    return isKpiDataAvailble ? (
      <>
        <div className="dashboard__kpi-title">
          <I18nText id="dashboard.kpi.title" />
        </div>
        <div className="dashboard__kpi-cards">
          <KpiCard
            title={<I18nText id="dashboard.kpi.profiles" />}
            previousAmount={profilesAddedKPI.past}
            currentAmount={profilesAddedKPI.present}
            descriptionText={<I18nText id="dashboard.kpi.description" />}
            width="full"
          />
          <KpiCard
            title={<I18nText id="dashboard.kpi.searches" />}
            previousAmount={searchesKPI.past}
            currentAmount={searchesKPI.present}
            descriptionText={<I18nText id="dashboard.kpi.description" />}
            width="full"
          />
          <KpiCard
            title={<I18nText id="dashboard.kpi.quotes" />}
            previousAmount={quotesKPI.past}
            currentAmount={quotesKPI.present}
            descriptionText={<I18nText id="dashboard.kpi.description" />}
            width="full"
          />
          <KpiCard
            title={<I18nText id="dashboard.kpi.bookings" />}
            previousAmount={bookingsKPI.past}
            currentAmount={bookingsKPI.present}
            descriptionText={<I18nText id="dashboard.kpi.description" />}
            width="full"
          />
        </div>
      </>
    ) : (
      <>
        <div className="dashboard__kpi-title">
          <I18nText id="dashboard.kpi.title" />
        </div>
        <div className="dashboard__kpi-icon">
          <img src={meter} alt="top-up" />
        </div>
        <div className="dashboard__kpi-empty-text">
          <I18nText id="dashboard.kpi.empty" />
        </div>
      </>
    );
  };

  const emptyTaskCard = () => (
    <Card
      version="v2"
      size="full"
      color="tertiary"
      className="col-grid col-bleed-y direction-row justify-center align-center"
      emptyCardImageSrc={
        <Icon name="tasks" color="tertiary" showBGColor={true} />
      }
      emptyCardText={<I18nText id="dashboard.briefing.tasks.no_task" />}
    />
  );

  const emptyActiveTravellerCard = () => (
    <Card
      version="v2"
      size="full"
      color="tertiary"
      className="col-grid col-bleed-y direction-row justify-center align-start"
      emptyCardImageSrc={
        <Icon name="seat" color="tertiary" showBGColor={true} />
      }
      emptyCardText={
        <I18nText id="dashboard.briefing.traveler.no_travellers" />
      }
    />
  );

  const briefingCard = () => {
    const isTravellerDataAvailable =
      travelerArriving + travelerDeparting + travelerTravelling > 0;

    return (
      <div className="col-grid col-bleed justify-space-between dashboard__briefing-content">
        <div className="dashboard__briefing-title">
          <I18nText id="dashboard.briefing.title" />
        </div>
        <div className="dashboard__briefing-cards">
          <div className="dashboard__briefing-online">
            <div className="dashboard__briefing-online-title">
              <I18nText id="dashboard.briefing.online.title" />
            </div>
            <div className="dashboard__briefing-online-users">
              {/* uncomment the following and repalce with data from chat server - refer to AF-561 */}
              {/* <span className="dashboard__briefing-stat">13</span>
              <I18nText id="dashboard.briefing.online.users" /> */}
              <I18nText id="dashboard.briefing.online.coming_soon" />
              {/* delete this after AF-561 */}
            </div>
            <div className="dashboard__briefing-online-travelers">
              {/* uncomment the following and repalce with data from chat server - refer to AF-561 */}
              {/* <span className="dashboard__briefing-stat">97</span>
              <I18nText id="dashboard.briefing.online.travelers" /> */}
              <I18nText id="dashboard.briefing.online.coming_soon" />
              {/* delete this after AF-561 */}
            </div>
          </div>
          <div className="col-grid col-bleed dashboard__briefing-traveler">
            <div className="col-12 col-bleed dashboard__briefing-traveler-title">
              <I18nText id="dashboard.briefing.traveler.title" />
            </div>
            {isTravellerDataAvailable ? (
              <div className="col-12 col-bleed dashboard__briefing-traveler-content">
                <div className="dashboard__briefing-traveler-arriving">
                  <span className="dashboard__briefing-stat">
                    {travelerArriving}
                  </span>
                  <I18nText id="dashboard.briefing.traveler.arriving" />
                </div>
                <div className="dashboard__briefing-traveler-departing">
                  <span className="dashboard__briefing-stat">
                    {travelerDeparting}
                  </span>
                  <I18nText id="dashboard.briefing.traveler.departing" />
                </div>
                <div className="dashboard__briefing-traveler-travelling">
                  <span className="dashboard__briefing-stat">
                    {travelerTravelling}
                  </span>
                  <I18nText id="dashboard.briefing.traveler.travelling" />
                </div>
              </div>
            ) : (
              emptyActiveTravellerCard()
            )}
          </div>
          <div className="col-12 col-grid col-bleed justify-center dashboard__briefing-tasks">
            <div className="dashboard__briefing-tasks-title">
              <I18nText id="dashboard.briefing.tasks.title" />
            </div>
            {isTaskLoading ? (
              <ContentLoaderPlaceholder
                numberOfLines={3}
                showBackground={false}
              />
            ) : (
              <>
                {totalTasksCount() ? (
                  <>
                    <div className="dashboard__briefing-tasks-description">
                      <span className="dashboard__briefing-stat">
                        {totalTasksCount()}
                      </span>
                      <I18nText id="dashboard.briefing.tasks.description" />
                    </div>
                    <div className="dashboard__briefing-tasks-list-wrapper">
                      {briefingTasks.map(
                        item =>
                          item.tasks.length > 0 && (
                            <div>
                              <span className="dashboard__briefing-tasks-list-workspace">
                                {item.workspace}
                              </span>
                              <div className="dashboard__briefing-tasks-list">
                                {briefingTaskRows(item.tasks)}
                              </div>
                            </div>
                          ),
                      )}
                    </div>
                  </>
                ) : (
                  <div className="col-grid col-bleed justify-center dashboard__briefing-tasks-list-wrapper--empty">
                    {emptyTaskCard()}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const fetchBriefingTasks = async () => {
    try {
      const { data } = await httpClient.get(routes.dashboard.briefingTasks());
      setBriefingTasks(data.briefingTasks);
    } catch (e) {
      setBriefingTasks([]);
    }

    setIsTaskLoading(false);
  };

  useEffect(() => {
    fetchBriefingTasks();
  }, []);

  return (
    <div className="container-full dashboard">
      <div className="grid">
        <div className="col-lg-6 col-md-6 col-12 dashboard__header">
          <Card version="v2" className="dashboard__header-card">
            <div className="dashboard__header-card-body">
              <div className="dashboard__header-card-body-text">
                {I18n.t('components.dashboard.header', { userName })}
              </div>
              <div className="dashboard__header-card-body-action">
                <Link
                  href="/settings"
                  type="icon-button"
                  size="large"
                  modifier="tertiary"
                >
                  <Icon name="settings" />
                </Link>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-lg-6 col-md-6 col-12 dashboard__account-manager">
          <Card
            version="v2"
            className="col-grid justify-center align-center dashboard__account-manager"
          >
            <div>
              {accountManagerFirstName ? (
                accountManagerSection()
              ) : (
                <div className="dashboard__account-manager-none">
                  <I18nText id="dashboard.account_manager.not_found" />
                </div>
              )}
            </div>
          </Card>
        </div>
      </div>
      <div className="grid">
        <div className="col-lg-6 col-md-6 col-12">
          <Card version="v2" className="dashboard__kpi">
            {kpiCards()}
          </Card>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <Card version="v2" className="dashboard__briefing">
            {briefingCard()}
          </Card>
        </div>
        {/* <div className="col-lg-4 col-md-6 col-12">
          <Card version="v2" className="dashboard__social">
            <div className="dashboard__social-title">
               <I18nText id="dashboard.social.title" />
            </div>
            {tweets.length > 0 ? (
              <>
                <div className="dashboard__social-twitter-card">
                  {tweets.map(tweet => (
                    <div>
                      <Tweet
                        key={`tweet-${uuidv4()}`}
                        userName={tweet.userName}
                        userHandle={tweet.userHandle}
                        description={tweet.description}
                        profilePictureUrl={tweet.profilePictureUrl}
                        mediaUrl={tweet.mediaUrl}
                        tweetedAt={tweet.tweetedAt}
                      />
                    </div>
                  ))}
                </div>
                <div className="dashboard__social-twitter-button">
                  <I18nText id="dashboard.social.twitter.follow" />{' '}
                  <span className="dashboard__social-twitter-button-text">
                    <a href="https://twitter.com/wellTravelHQ">@welltravelHQ</a>
                  </span>{' '}
                  <I18nText id="dashboard.social.twitter.follow_on" />
                  <span className="dashboard__social-twitter-button-logo">
                    <img src={twitterIcon} alt="twitter icon" />
                  </span>
                </div>
              </>
            ) : (
              emptySocialCard()
            )}
          </Card>
        </div> */}
      </div>
      {/* Remove this when Promotional Space is implemented */}
      {/* <div className="col-12 col-bleed-x">
        <Card version="v2" className="dashboard__promotion">
          <div className="dashboard__promotion-empty-text">
            <I18nText id="dashboard.promotion.empty" />
          </div>
        </Card>
      </div> */}
      <div className="grid hidden-xxs hidden-xs hidden-sm">
        <div className="col-lg-6 col-md-6 col-12">
          <div className="dashboard__news">
            <div className="grid">
              <div className="dashboard__news-title col-12">
                <I18nText id="dashboard.news.travel_news.header" />
              </div>
              {allTravelNews}
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <div className="dashboard__news">
            <div className="grid">
              <div className="dashboard__news-title col-12">
                <I18nText id="dashboard.news.welltravel_news.header" />
              </div>
              {onlyWelltravelNews}
            </div>
          </div>
        </div>
      </div>

      <div className="grid hidden-xlg hidden-lg hidden-md">
        <div className="dashboard__news-section col-12">
          <div className="dashboard__news-title">
            <I18nText id="dashboard.news.header" />
          </div>
        </div>
        <div className="col-12">
          <PillTabs items={newsListTabs} />
        </div>
      </div>
      {/* Remove this when Promotional Space is implemented */}
      {/* <div className="col-12 col-bleed-x">
        <Card version="v2" className="dashboard__promotion">
          <div className="dashboard__promotion-empty-text">
            <I18nText id="dashboard.promotion.empty" />
          </div>
        </Card>
      </div> */}
    </div>
  );
};

dashboard.defaultProps = {
  userName: null,
  accountManagerFirstName: null,
  accountManagerLastName: null,
  accountManagerAvatar: null,
  tweets: [],
};

dashboard.propTypes = {
  userName: PropTypes.string,
  accountManagerFirstName: PropTypes.string,
  accountManagerLastName: PropTypes.string,
  accountManagerAvatar: PropTypes.string,
  profilesAddedKPI: PropTypes.shape({
    past: PropTypes.number,
    present: PropTypes.number,
  }).isRequired,
  searchesKPI: PropTypes.shape({
    past: PropTypes.number,
    present: PropTypes.number,
  }).isRequired,
  quotesKPI: PropTypes.shape({
    past: PropTypes.number,
    present: PropTypes.number,
  }).isRequired,
  bookingsKPI: PropTypes.shape({
    past: PropTypes.number,
    present: PropTypes.number,
  }).isRequired,
  travelerDeparting: PropTypes.number.isRequired,
  travelerArriving: PropTypes.number.isRequired,
  travelerTravelling: PropTypes.number.isRequired,
  tweets: PropTypes.arrayOf(
    PropTypes.shape({
      userName: PropTypes.string.isRequired,
      userHandle: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string.isRequired,
      mediaUrl: PropTypes.string.isRequired,
      tweetedAt: PropTypes.string.isRequired,
    }),
  ),
  travelNews: PropTypes.PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      teaser: PropTypes.string,
      url: PropTypes.string,
      image_url: PropTypes.shape({
        small: PropTypes.string,
        medium: PropTypes.string,
        large: PropTypes.string,
      }),
    }),
  ).isRequired,
  welltravelNews: PropTypes.PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      teaser: PropTypes.string,
      url: PropTypes.string,
      image_url: PropTypes.shape({
        small: PropTypes.string,
        medium: PropTypes.string,
        large: PropTypes.string,
      }),
    }),
  ).isRequired,
};

export default dashboard;
